var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5L6.35833 13.6408M6.3625 13.6366L4.04583 11.32C3.25083 10.5258 4.05083 8.82329 5.1375 8.75496C6.11917 8.69246 8.39167 9.04829 9.1475 8.29246L11.2225 6.21746C11.7367 5.70246 11.41 4.55079 11.3767 3.91579C11.3283 3.06913 12.675 2.02329 13.3892 2.73746L17.2617 6.61079C17.9783 7.32579 16.9283 8.66829 16.0842 8.62329C15.4492 8.58996 14.2967 8.26329 13.7817 8.77746L11.7067 10.8525C10.9517 11.6083 11.3067 13.88 11.245 14.8616C11.1767 15.9491 9.47417 16.7491 8.67833 15.9533L6.3625 13.6366Z",
    stroke: "#626262",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.b5e56bb338f6c32ebd0cc15dc34a08f1.svg";
export { ForwardRef as ReactComponent };